document.addEventListener('DOMContentLoaded', () => {
  const button = document.getElementById('BackToTop');
  if (!button) return;

  const SHOW_AFTER = 400;
  let ticking = false;

  function updateVisibility() {
    button.classList.toggle('is-visible', window.scrollY > SHOW_AFTER);
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    },
    { passive: true }
  );

  updateVisibility();

  button.addEventListener('click', () => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
  });
});
